import React from 'react';
import { connect } from 'react-redux';
import HoverActionHeader from '@/components/HoverActionHeader';
import { editCohort } from '../actions';

const CohortFieldHeader = ({
  code,
  category,
  value,
  icon,
  canEdit,
  showEdit,
  isSystem,
}) => (
  <HoverActionHeader
    canEdit={canEdit}
    showEdit={() => showEdit(category, code)}
    isSystem={isSystem}
    value={value}
    icon={icon}
    className="aridhia-cohort-list-header"
  />
);

const mapDispatchToProps = {
  showEdit: editCohort,
};

export default connect(null, mapDispatchToProps)(CohortFieldHeader);
